import Vue from "vue";

Vue.component("notification-pages", {
	props: [
		"language",
		"isReadOnly",
		"vmData",
		"helperCode"
	],
	data() {
		return {
			items: [],
			dialects: [],
		};
	},
	methods: {
		getDialects: function () {
			this.$services.dialects.getForDropdown({
				language: this.language,
				isMainLanguagesOnTop: true
			})
				.then((data) => {
					this.dialects = data.items;
				});
		},
		addItem() {
			const displayOrder = this.items.length + 1;
			this.items.push({ dialectCode: 'EN', numberOfPages: 0, displayOrder: displayOrder });
			this.$emit("update:vmData", this.items);
		},
		deleteItem(value) {
			const items = this.items.filter(function(item) {
				return item !== value;
			});

			let displayOrder = 0;
			items.forEach(function(item) {
				displayOrder++;
				item.displayOrder = displayOrder;
			});

			this.items = items;
			this.$emit("update:vmData", this.items);
		}
	},
	computed: {
		addNew() {
			return htmlEntity.decode(window.labels.addNew);
		},
		numberOfPagesAndLanguages() {
			return htmlEntity.decode(window.labels.numberOfPagesAndLanguages);
		},
		dialectLanguage() {
			return htmlEntity.decode(window.labels.language);
		},
		numberOfPages() {
			return htmlEntity.decode(window.labels.numberOfPages);
		},
	},
	mounted: function () {
		this.getDialects();

		if (this.vmData) {
			this.items = this.vmData;
		}
	},
	template: `
		<div class="columns">
			<div class="column is-4">
				<b-field>
					<template #label>
						<div style="display: flex">
							<span>{{numberOfPagesAndLanguages}}</span>							
							<p class="control" v-if="helperCode">
								<helper-icon :code-to-display="helperCode" :size-dimension="'is-very-large'">
								</helper-icon>
							</p>
						</div>
					</template>
					<b-table :striped="true"
							 :narrowed="true"
							 :hoverable="true"
							 :data="items"
							 :show-detail-icon="false"
							 ref="tableref"
							 detailed
							 detail-key="id">

						<b-table-column field="language" :label="dialectLanguage" width="45%" v-slot="props">
							<b-select :disabled="isReadOnly" v-model="props.row.dialectCode" expanded>
								<option v-for="dialect in dialects"
										:value="dialect.value"
										:key="dialect.value">
									{{ dialect.text }}
								</option>
							</b-select>
						</b-table-column>

						<b-table-column field="numberOfPages" :label="numberOfPages" width="50%" v-slot="props">
							<b-input type="number" :disabled="isReadOnly" v-model="props.row.numberOfPages"></b-input>
						</b-table-column>

						<b-table-column v-if="!isReadOnly" field="" label="" width="5%" v-slot="props">
							<b-button @click="deleteItem(props.row)"><i class="fas fa-trash-alt has-text-danger"></i></b-button>
						</b-table-column>
					</b-table>
				</b-field>

				<b-field v-if="!isReadOnly" class="file is-danger">
					<b-button @click="addItem">{{ addNew }}</b-button>
				</b-field>
			</div>
		</div>
	`
});